module.exports = __webpack_public_path__ + "html/registration-form.template.html";